export default __webpack_public_path__ + "static/media/icon_titulos_selected.fdef943b.svg";